export const SET_LIST = "SET_LIST";
export const CLEAR_LIST = "CLEAR_LIST";
export const SET_CURRENT = "SET_CURRENT";
